import { createSelector } from '@ngrx/store';

import { PremiumDiff } from '@models/swagger';
import { State } from './reducer';
import { selectDifferenceState } from '../selectors';

export const getData = createSelector(selectDifferenceState, (state: State) => state.data);

export const getError = createSelector(selectDifferenceState, (state: State) => state.error);

export const getLoading = createSelector(selectDifferenceState, (state: State) => state.loading);

export const mapData = <T>(fn: (data: PremiumDiff[]) => T) =>
  createSelector(selectDifferenceState, (state: State) => fn(state.data));
